import React from 'react'

const FasterDeliveryIcom = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={60}
                height={60}
                x={0}
                y={0}
                viewBox="0 0 512 512"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <path
                        fill="#ffd064"
                        d="M433.855 80.781h-96.947v-42.81a9.24 9.24 0 0 1 9.239-9.239h78.469a9.24 9.24 0 0 1 9.239 9.239z"
                        opacity={1}
                        data-original="#ffd064"
                    />
                    <path
                        fill="#ffc250"
                        d="M424.616 28.732h-21.112a9.238 9.238 0 0 1 9.239 9.239v42.81h21.112v-42.81a9.24 9.24 0 0 0-9.239-9.239z"
                        opacity={1}
                        data-original="#ffc250"
                    />
                    <circle
                        cx="385.381"
                        cy="176.918"
                        r="119.119"
                        fill="#f9f6f6"
                        opacity={1}
                        data-original="#f9f6f6"
                        className=""
                    />
                    <path
                        fill="#dddaec"
                        d="M385.381 57.799c-4.241 0-8.429.226-12.556.658 59.885 6.274 106.563 56.914 106.563 118.461 0 61.546-46.678 112.187-106.563 118.461 4.127.432 8.315.658 12.556.658 65.788 0 119.119-53.331 119.119-119.119S451.169 57.799 385.381 57.799z"
                        opacity={1}
                        data-original="#dddaec"
                    />
                    <path
                        fill="#80b4fb"
                        d="M491.135 430.298H69.139a6.78 6.78 0 0 1-6.78-6.78V232.544c0-5.948 4.822-10.769 10.769-10.769h309.155a19.34 19.34 0 0 1 14.278 6.294l102.892 112.592a19.276 19.276 0 0 1 5.046 13.003v63.269c.001 7.381-5.983 13.365-13.364 13.365z"
                        opacity={1}
                        data-original="#80b4fb"
                        className=""
                    />
                    <path
                        fill="#61a2f9"
                        d="M499.453 340.661 396.561 228.069a19.34 19.34 0 0 0-14.278-6.294h-22.014a19.34 19.34 0 0 1 14.278 6.294l102.892 112.592a19.276 19.276 0 0 1 5.046 13.003v63.269c0 7.381-5.984 13.365-13.365 13.365h22.014c7.381 0 13.365-5.984 13.365-13.365v-63.269a19.265 19.265 0 0 0-5.046-13.003z"
                        opacity={1}
                        data-original="#61a2f9"
                    />
                    <path
                        fill="#e4f6ff"
                        d="M396.561 228.069a19.34 19.34 0 0 0-14.278-6.294H340.78v96.667c0 4.194 3.4 7.594 7.594 7.594h137.714z"
                        opacity={1}
                        data-original="#e4f6ff"
                    />
                    <path
                        fill="#d3effb"
                        d="m374.547 228.069 89.528 97.968h22.014l-89.528-97.968a19.34 19.34 0 0 0-14.278-6.294h-22.014a19.34 19.34 0 0 1 14.278 6.294z"
                        opacity={1}
                        data-original="#d3effb"
                    />
                    <circle
                        cx="418.275"
                        cy="433.143"
                        r="50.125"
                        fill="#26457d"
                        opacity={1}
                        data-original="#26457d"
                    />
                    <path
                        fill="#21386b"
                        d="M418.275 383.018c-2.839 0-5.618.248-8.328.702 23.717 3.968 41.797 24.579 41.797 49.423 0 24.845-18.079 45.455-41.797 49.423 2.71.453 5.489.702 8.328.702 27.683 0 50.125-22.442 50.125-50.125s-22.442-50.125-50.125-50.125z"
                        opacity={1}
                        data-original="#21386b"
                    />
                    <circle
                        cx="418.275"
                        cy="433.143"
                        r="16.656"
                        fill="#f9f6f6"
                        opacity={1}
                        data-original="#f9f6f6"
                        className=""
                    />
                    <path
                        fill="#dddaec"
                        d="M418.275 416.487c-2.425 0-4.722.53-6.801 1.462 5.806 2.603 9.856 8.421 9.856 15.195s-4.051 12.592-9.856 15.195a16.571 16.571 0 0 0 6.801 1.462c9.199 0 16.656-7.457 16.656-16.657s-7.457-16.657-16.656-16.657z"
                        opacity={1}
                        data-original="#dddaec"
                    />
                    <circle
                        cx="168.58"
                        cy="433.143"
                        r="50.125"
                        fill="#26457d"
                        opacity={1}
                        data-original="#26457d"
                    />
                    <path
                        fill="#21386b"
                        d="M168.581 383.018c-2.839 0-5.618.248-8.328.702 23.717 3.968 41.797 24.579 41.797 49.423 0 24.845-18.079 45.455-41.797 49.423 2.71.453 5.489.702 8.328.702 27.683 0 50.125-22.442 50.125-50.125s-22.442-50.125-50.125-50.125z"
                        opacity={1}
                        data-original="#21386b"
                    />
                    <circle
                        cx="168.58"
                        cy="433.143"
                        r="16.656"
                        fill="#f9f6f6"
                        opacity={1}
                        data-original="#f9f6f6"
                        className=""
                    />
                    <path
                        fill="#dddaec"
                        d="M168.581 416.487c-2.425 0-4.722.53-6.801 1.462 5.806 2.603 9.856 8.421 9.856 15.195s-4.051 12.592-9.856 15.195a16.571 16.571 0 0 0 6.801 1.462c9.199 0 16.656-7.457 16.656-16.657s-7.457-16.657-16.656-16.657z"
                        opacity={1}
                        data-original="#dddaec"
                    />
                    <path
                        fill="#f9f6f6"
                        d="m153.282 342.77-5.838-5.998 35.571-34.623-35.571-34.624 5.838-5.998c8.074-8.295 21.343-8.474 29.638-.4l31.174 30.343c1.616 1.573 2.932 3.454 3.704 5.573 2.05 5.631.522 11.673-3.529 15.615l-31.349 30.513c-8.294 8.073-21.564 7.894-29.638-.401z"
                        opacity={1}
                        data-original="#f9f6f6"
                        className=""
                    />
                    <path
                        d="M385.381 102.82c4.143 0 7.5-3.357 7.5-7.5V85.238c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5V95.32a7.5 7.5 0 0 0 7.5 7.5zM466.98 169.418c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h10.081c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5zM293.701 169.418c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h10.082c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5zM418.275 408.987c-13.32 0-24.157 10.837-24.157 24.156s10.837 24.156 24.157 24.156c13.319 0 24.156-10.837 24.156-24.156s-10.837-24.156-24.156-24.156zm0 33.312c-5.05 0-9.157-4.107-9.157-9.156s4.107-9.156 9.157-9.156c5.049 0 9.156 4.107 9.156 9.156s-4.107 9.156-9.156 9.156zM144.424 433.143c0 13.319 10.837 24.156 24.157 24.156s24.156-10.837 24.156-24.156-10.836-24.156-24.156-24.156-24.157 10.836-24.157 24.156zm33.313 0c0 5.049-4.107 9.156-9.156 9.156s-9.157-4.107-9.157-9.156 4.108-9.156 9.157-9.156 9.156 4.107 9.156 9.156zM219.501 318.031c8.467-8.241 9.443-22.576-.175-31.936l-31.174-30.345c-11.246-10.942-29.299-10.7-40.244.544l-5.838 5.998a7.5 7.5 0 0 0 .143 10.605l30.05 29.25-30.05 29.249a7.5 7.5 0 0 0-.143 10.605l5.838 5.998c10.981 11.281 28.995 11.495 40.244.543zm-60.844 19.507-.607-.623 30.197-29.393a7.5 7.5 0 0 0 0-10.748L158.05 267.38l.607-.623c5.178-5.319 13.715-5.434 19.033-.258l31.174 30.345c3.327 3.238 2.882 7.802.175 10.438l-31.349 30.513c-5.293 5.151-13.813 5.106-19.033-.257zM377.881 176.918c0 4.143 3.357 7.5 7.5 7.5h25.506c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-18.006v-46.706c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5zM128.121 112.82h129.141c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5H128.121c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5zM96.817 151.567h134.052c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5H96.817c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5zM173.508 171.121c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h66.705c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5zM110.275 171.121c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h33.292c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5zM7.5 289.406h27.43c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5H7.5c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5zM27.5 355.47h-20c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h20c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5zM115.733 291.959H88.985c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h26.748c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5z"
                        fill="#000000"
                        opacity={1}
                        data-original="#000000"
                        className=""
                    />
                    <path
                        d="M456.009 282.004C490.759 258.593 512 219.141 512 176.917c0-20.068-4.565-39.271-13.57-57.072a7.5 7.5 0 0 0-13.385 6.769C492.977 142.298 497 159.223 497 176.917c0 37.974-19.494 73.403-51.238 93.873l-43.665-47.781a26.898 26.898 0 0 0-19.814-8.735H280.177c-4.256-11.968-6.415-24.511-6.415-37.357 0-61.547 50.072-111.618 111.619-111.618 31.926 0 62.391 13.724 83.583 37.653a7.499 7.499 0 0 0 10.587.642 7.499 7.499 0 0 0 .642-10.587 126.717 126.717 0 0 0-38.838-29.635V37.971c0-9.23-7.509-16.739-16.739-16.739h-78.469c-9.23 0-16.739 7.509-16.739 16.739v25.394c-41.819 20.698-70.646 63.818-70.646 113.552 0 12.784 1.892 25.304 5.617 37.357H73.128c-9.567 0-17.426 7.396-18.193 16.77H27.5c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h27.359v72.492H7.5c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h47.359v21.937a7.498 7.498 0 0 0 0 14.992v53.052c0 7.874 6.406 14.279 14.279 14.279h20.179v5.221h-23.4c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h30.9a7.5 7.5 0 0 0 7.5-7.5v-12.721h6.843c2.38 29.604 27.215 52.97 57.421 52.97a57.637 57.637 0 0 0 28.455-7.521 7.5 7.5 0 0 0-7.419-13.038 42.599 42.599 0 0 1-21.036 5.559c-23.503 0-42.625-19.121-42.625-42.625s19.122-42.625 42.625-42.625 42.625 19.121 42.625 42.625c0 6.408-1.389 12.571-4.129 18.318a7.5 7.5 0 1 0 13.54 6.455A56.962 56.962 0 0 0 226 437.796h134.854c2.38 29.604 27.215 52.97 57.421 52.97s55.04-23.366 57.421-52.97h15.439c11.505 0 20.865-9.36 20.865-20.865v-63.27a26.71 26.71 0 0 0-7.01-18.062zM344.408 37.971c0-.959.78-1.739 1.739-1.739h78.469c.959 0 1.739.78 1.739 1.739v19.166a126.436 126.436 0 0 0-40.974-6.837c-14.333 0-28.116 2.398-40.974 6.807V37.971zm46.617 195.158 78.05 85.407h-55.947c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h69.655l11.135 12.185c4.54 4.968 2.632 10.359 3.082 16.08h-5.782c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5H497v11.098h-43.101c-9.812-7.743-22.183-12.381-35.623-12.381s-25.811 4.638-35.623 12.381h-81.717V229.275h32.347v89.167c0 8.323 6.771 15.095 15.094 15.095h34.767c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-34.767a.095.095 0 0 1-.094-.095v-89.167h34.002a11.87 11.87 0 0 1 8.74 3.854zm-29.427 189.669h-60.664v-19.899h68.318a57.24 57.24 0 0 0-7.654 19.899zm-143.995-19.899h68.331v19.899h-60.677a57.24 57.24 0 0 0-7.654-19.899zm-147.744 0h49.698a57.24 57.24 0 0 0-7.654 19.899H69.859zm63.098-15H69.859V370.47h32.5c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5h-32.5v-21.934h32.5c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5h-32.5v-85.992a3.273 3.273 0 0 1 3.269-3.27h212.806v158.624h-81.73c-9.812-7.743-22.183-12.381-35.623-12.381s-25.811 4.639-35.624 12.382zm285.318 87.869c-23.504 0-42.625-19.121-42.625-42.625s19.121-42.625 42.625-42.625 42.625 19.121 42.625 42.625-19.121 42.625-42.625 42.625zm72.859-52.97h-16.183a57.24 57.24 0 0 0-7.654-19.899H497v14.034a5.872 5.872 0 0 1-5.866 5.865z"
                        fill="#000000"
                        opacity={1}
                        data-original="#000000"
                        className=""
                    />
                </g>
            </svg>
        </>
    )
}

export default FasterDeliveryIcom